<template>
  <div class="card-wrapper">
    <div class="card contact contact-info-block">
      <h3 v-if="withToken"><slot name="txtHeadline">Lorem ipsum</slot></h3>
      <div class="app-esim-push" v-if="eSimQRInformationLoaded && eSimStatusLoaded && !eSimInstalled">
        <div class="subline">
          <slot name="txtSublineDefault">Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate, laborum?</slot>
        </div>
        <div class="card-wrapper esim-mode push">
          <div class="card">
            <div class="accordion-head">
              <div class="accordion-toggle">
                <h3 v-b-toggle.accordion-push><slot name="lblPushToggle">Push</slot></h3>
                <b-button class="accordion-toggle" v-b-toggle.accordion-push></b-button>
              </div>
              <span><slot name="txtPushSubline">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Neque, accusamus.</slot></span>
            </div>
            <b-collapse id="accordion-push" v-model="pushCollapseVisible" accordion="mode-accordion" @shown="showContent('accordion-push')">
              <div class="accordion-content">
                <div class="infotext"><slot name="txtPushInfo">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
                <div class="downloads"><slot name="txtPushDownloads">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
                <b-form>
                  <b-form-group class="mandatory mt-0 pr-0" :class="vflowGetFeedbackClasses('eID')" v-if="possibleActions.includes('PUSH_ASSIGN')">
                    <label for="eID"><slot name="lblEID">eID</slot></label>
                    <b-form-input
                      name="eID"
                      id="eID"
                      type="number"
                      v-model="eID"
                      required
                      @blur="vflowInputBlurred('eID')"
                      @focus="vflowInputFocused('eID')"
                      @input="$v.eID.$touch"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback>
                      <slot name="txtInvalidLengthEIDLiveFeedback" v-if="!$v.eID.maxLength || !$v.eID.minLength ">
                        Dies ist keine gültige eID. Die eID besteht aus 32 Zahlen.
                      </slot>
                      <slot name="txtInvalidEIDLiveFeedback" v-if="($v.eID.maxLength && $v.eID.minLength) && !$v.eID.modulo">
                        Dies ist keine gültige eID.
                      </slot>
                    </b-form-invalid-feedback>
                    <button type="button" class="filled yellow performPush" @click="performESimPush()"><slot name="lblPushButton">PUSH IT!</slot></button>
                  </b-form-group>

                  <div class="info-box inProgress" v-if="eSimDownloadInProgress">
                    <div class="subline" v-if="!showProgressError">
                      <slot name="txtSublineESimDeleteInProgress" v-if="deleteInProgress">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Labore consequatur voluptatem repudiandae ab adipisci nulla facilis dolores atque rem facere.</slot>
                      <slot name="txtSublineESimInProgress" v-else>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Labore consequatur voluptatem repudiandae ab adipisci nulla facilis dolores atque rem facere.</slot>
                    </div>
                    <div class="error-box" v-if="showProgressError">
                      <slot name="errorNoPushProgressChange">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Labore consequatur voluptatem repudiandae ab adipisci nulla facilis dolores atque rem facere.</slot>
                    </div>
                  </div>

                  <div class="info-box" v-else-if="possibleActions.includes('PUSH_DEASSIGN')">
                    <div>
                      <slot name="txtPushDownloadInProgess">Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia dolorum sequi repellat animi nisi ab repellendus officiis a, ex consectetur?</slot>
                    </div>
                    <button type="button" @click="openDeleteModal()" class="performDelete"><slot name="lblPushDeleteButton">PUSH-DELETE IT!</slot></button>
                    <SimonModal
                      :is-visible="showDeleteModal"
                      id="esim-push-delete-modal"
                      @hide="showDeleteModal = false"
                      show-footer-buttons
                      @btnLeft="showDeleteModal = false"
                      @btnRight="performESimPushDelete"
                      :btn-left-title="getSlotText('lblDeleteModalCancelButton') !== '' ? getSlotText('lblDeleteModalCancelButton')  : 'Abbrechen'"
                      :btn-right-title="getSlotText('lblDeleteModalDeleteButton') !== '' ? getSlotText('lblDeleteModalDeleteButton') : 'Jetzt entkoppeln'"

                    >
                      <template v-slot:modalTitle>
                          <h1><slot name="lblDeleteModalHeadline">Lorem, ipsum dolor.</slot></h1>
                      </template>
                      <slot name="txtDeleteModal">Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa obcaecati doloremque quis ipsum officiis deleniti reiciendis quidem dolor consectetur iusto.</slot>
                    </SimonModal>
                  </div>
                </b-form>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="card-wrapper esim-mode manual">
          <div class="card">
            <div class="accordion-head">
              <div class="accordion-toggle">
                <h3 v-b-toggle.accordion-manual><slot name="lblManualToggle">Manual</slot></h3>
                <b-button class="accordion-toggle" v-b-toggle.accordion-manual></b-button>
              </div>
              <span><slot name="txtManualSubline">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Neque, accusamus.</slot></span>
            </div>
            <b-collapse id="accordion-manual" accordion="mode-accordion" @shown="showContent('accordion-manual')">
              <div class="accordion-content">
                <div class="infotext"><slot name="txtManualInfo">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
                <div class="downloads"><slot name="txtManualDownloads">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
                <b-form>
                  <b-form-group class="mt-0 pr-0">
                    <label for="manual_smdp-address"><slot name="lblSMDPAddress">SMDPAddress</slot></label>
                    <b-form-input
                      name="manual_smdp-address"
                      id="manual_smdp-address"
                      type="text"
                      v-model="smdpAddress"
                      disabled
                    >
                    </b-form-input>
                    <img src="/files/flash/images/svg-icons/icon-copy.svg" alt="copy" height="24" width="24" class="icon" @click="copyToClipboard(smdpAddress, 'txtCopySMDPSuccessToast')" />
                  </b-form-group>
                  <b-form-group class="mt-0 pr-0">
                    <label for="manual_activation-code"><slot name="lblActivationCode">ActivationCode</slot></label>
                    <b-form-input
                      name="manual_activation-code"
                      id="manual_activation-code"
                      type="text"
                      v-model="activationCode"
                      disabled
                    >
                    </b-form-input>
                    <img src="/files/flash/images/svg-icons/icon-copy.svg" alt="copy" height="24" width="24" class="icon" @click="copyToClipboard(activationCode, 'txtCopyActivationCodeSuccessToast')" />
                  </b-form-group>
                  <b-form-group class="mt-0 pr-0">
                    <label for="manual_confirmation"><slot name="lblConfirmationCode">ConfirmationCode</slot></label>
                    <b-form-input
                      name="manual_confirmation"
                      id="manual_confirmation"
                      type="password"
                      v-model="confirmationCode"
                      disabled
                      ref="manualConfirmation"
                    >
                    </b-form-input>
                    <img :src="manualConfirmationIcon" alt="show" height="24" width="24" class="icon" @click="showManualConfirmation()" />
                  </b-form-group>
                </b-form>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="card-wrapper esim-mode qrcode">
          <div class="card">
            <div class="accordion-head">
              <div class="accordion-toggle">
                <h3 v-b-toggle.accordion-qrcode><slot name="lblQRCodeToggle">QR</slot></h3>
                <b-button class="accordion-toggle" v-b-toggle.accordion-qrcode></b-button>
              </div>
              <span><slot name="txtQRCodeSubline">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Neque, accusamus.</slot></span>
            </div>
            <b-collapse id="accordion-qrcode" accordion="mode-accordion" @shown="showContent('accordion-qrcode')">
              <div class="accordion-content">
                <div class="infotext"><slot name="txtQRCodeInfo">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
                <div class="downloads"><slot name="txtQRCodeDownloads">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
                <img :src="imageSrc" class="qrcode">
                <b-form>
                  <b-form-group class="mt-0 pr-0">
                    <label for="qrcode_confirmation"><slot name="lblConfirmationCode">ConfirmationCode</slot></label>
                    <b-form-input
                      name="qrcode_confirmation"
                      id="qrcode_confirmation"
                      type="password"
                      v-model="confirmationCode"
                      disabled
                      ref="qrcodeConfirmation"
                    >
                    </b-form-input>
                    <img :src="qrcodeConfirmationIcon" alt="show" height="24" width="24" class="icon" @click="showQRCodeConfirmation()" />
                  </b-form-group>
                </b-form>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="card card--info" v-if="withToken">
          <slot name="txtInfoBox">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eos, tempora.</slot>
        </div>
      </div>
      <div class="app-esim-push disabled" v-else>
        <div class="subline">
          <slot name="txtSublineESimInstalled">Esim installiert</slot>
        </div>
        <div class="esim-mode push">
          <h3><slot name="lblPushToggle">Push</slot></h3>
          <div class="infotext"><slot name="txtPushInfoDisabled">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
          <div class="downloads"><slot name="txtPushDownloads">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
        </div>
        <div class="esim-mode manual">
          <h3><slot name="lblManualToggle">Manual</slot></h3>
          <div class="infotext"><slot name="txtManualInfoDisabled">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
          <div class="downloads"><slot name="txtManualDownloads">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
        </div>
        <div class="esim-mode qrcode">
          <h3><slot name="lblQRCodeToggle">QR</slot></h3>
          <div class="infotext"><slot name="txtQRCodeInfoDisabled">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
          <div class="downloads"><slot name="txtQRCodeDownloads">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit, soluta?</slot></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import useFeature from '@/mixins/useFeature'
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'PushCart',
  components: { SimonModal },
  mixins: [
    validationFlow,
    validationMixin,
    useFeature('esimPush')
  ],
  props: {
    eSimQRInformation: {
      type: Object,
      default: () => {
        return null
      }
    },
    eSimQRInformationLoaded: {
      type: Boolean,
      default: false
    },
    eSimStatus: {
      type: Object,
      default: () => {
        return null
      }
    },
    eSimStatusLoaded: {
      type: Boolean,
      default: false
    },
    showProgressError: {
      type: Boolean,
      default: false
    },
    withToken: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      eID: null,
      activeAccordion: null,
      pushCollapseVisible: false,
      showDeleteModal: false,
      manualConfirmationIcon: '/files/flash/images/svg-icons/icon-password-open.svg',
      qrcodeConfirmationIcon: '/files/flash/images/svg-icons/icon-password-open.svg'
    }
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (isJustShown) {
        this.activeAccordion = collapseId
        // track only when opening, whe do not track 'close' here
        const data = {
          information_action: 'reveal',
          information_name: collapseId.replace('accordion-', '') + ' activation',
          information_ui_type: 'panel',
          information_trigger: 'accordion'
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('information', data)
        }
      } else if (collapseId === this.activeAccordion) {
        document.getElementById('main').scrollIntoView({ behavior: 'smooth' })
      }
    })
  },
  methods: {
    performESimPush () {
      this.vflowForceFeedback()
      if (!this.$v.$error && !this.$v.$invalid) {
        this.$emit('performESimPush', this.eID)
      } else {
        // ensure live feedback for validation errors
        this.vFlowScrollToFirstElemment()
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    performESimPushDelete () {
      this.$emit('performESimDeassign')
    },
    showContent (id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'end' })
    },
    copyToClipboard (info, successMessage) {
      try {
        // Webview Handling
        if (window.WebView !== undefined && (window.isIOS === undefined || window.isIOS === false)) {
          if (window.App !== undefined && window.App.copyToClipBoard !== undefined) {
            window.App.copyToClipBoard(info)
            this.successToast(this.getSlotText(successMessage, 'Die Information wurde in die Zwischenablage kopiert!'))
          }
        } else {
          navigator.clipboard.writeText(info).then(() => {
            this.successToast(this.getSlotText(successMessage, 'Die Information wurde in die Zwischenablage kopiert!'))
          }).catch(() => {
            this.errorToast(this.getSlotText('txtCopyErrorToast', 'Hoppla, da ist was schief gelaufen!'))
          })
        }
      } catch (err) {
        this.errorToast(this.getSlotText('txtCopyErrorToast', 'Hoppla, da ist was schief gelaufen!'))
      }
    },
    showQRCodeConfirmation () {
      if (this.$refs.qrcodeConfirmation.$el.type === 'password') {
        this.$refs.qrcodeConfirmation.$el.type = 'text'
        this.qrcodeConfirmationIcon = '/files/flash/images/svg-icons/icon-password-close.svg'
      } else {
        this.$refs.qrcodeConfirmation.$el.type = 'password'
        this.qrcodeConfirmationIcon = '/files/flash/images/svg-icons/icon-password-open.svg'
      }
    },
    showManualConfirmation () {
      if (this.$refs.manualConfirmation.$el.type === 'password') {
        this.$refs.manualConfirmation.$el.type = 'text'
        this.manualConfirmationIcon = '/files/flash/images/svg-icons/icon-password-close.svg'
      } else {
        this.$refs.manualConfirmation.$el.type = 'password'
        this.manualConfirmationIcon = '/files/flash/images/svg-icons/icon-password-open.svg'
      }
    },
    openDeleteModal () {
      this.showDeleteModal = true
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.trackInformation('info remove esim', 'reveal', 'overlay', 'button')
      }
    },
    modulo (divident, divisor) {
      var partLength = 10
      while (divident.length > partLength) {
        var part = divident.substring(0, partLength)
        divident = (part % divisor) + divident.substring(partLength)
      }
      return divident % divisor
    }
  },
  computed: {
    eSimInstalled: function () {
      return this.eSimStatus?.eSimStatus === 'INSTALLED'
    },
    eSimDownloadInProgress: function () {
      return ['DOWNLOAD_IN_PROGRESS', 'IN_PROGRESS'].includes(this.eSimStatus?.eSimStatus)
    },
    possibleActions: function () {
      return this.eSimStatus?.possibleActions && this.eSimStatus?.possibleActions.length > 0 ? this.eSimStatus.possibleActions : []
    },
    deleteInProgress: function () {
      return this.eSimDownloadInProgress && !this.eSimStatus?.eid
    },
    confirmationCode: function () {
      return this.eSimQRInformation?.code?.confirmationCode || ''
    },
    smdpAddress: function () {
      return this.eSimQRInformation?.smdpPlus || ''
    },
    activationCode: function () {
      return this.eSimQRInformation?.code?.activationCode || ''
    },
    imageSrc: function () {
      return 'data:image/png;base64, ' + this.eSimQRInformation?.code?.qrCode || ''
    }
  },
  validations () {
    return {
      eID: {
        required,
        minLength: minLength(32),
        maxLength: maxLength(32),
        checksum (value) {
          const stringvalue = '' + value
          if (stringvalue.length < 32) {
            return false
          }
          return this.modulo(stringvalue, 97) === 1
        }
      }
    }
  }
}
</script>
